import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
export default function HeroSection() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="dark relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Inter:wght@300;400;500;600&display=swap');`}</style>

      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/Fotolia_90701121_M.jpg" className="w-full h-auto min-h-full object-cover object-center" alt="Hero background" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/60 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
      </div>

      <header className="relative z-20 flex items-start justify-between px-6 pt-8 text-primary-foreground !bg-[rgba(0,0,0,1)] md:px-12 lg:px-20">
        <div className={`flex flex-col gap-2 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/pequen_CC_83o-sin-fondo.png" alt="Laboratorio Alineadores Dentales" className="w-full h-auto max-w-[180px] md:max-w-[220px]" src="https://destined-muskox.10web.cloud/wp-content/uploads/2026/05/nuevo-logo-Rio.png" src="https://destined-muskox.10web.cloud/wp-content/uploads/2026/05/nuevo-logo-Rio-e1779666083809.png" />
          <div className="mt-1">
            <p className="text-white/90 text-xs md:text-sm font-light tracking-[0.18em] uppercase" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              Laboratorio Alineadores Dentales
            </p>
            <p className="text-white/60 text-[10px] md:text-xs font-light tracking-wide mt-0.5 max-w-[280px]" style={{
            fontFamily: "'Inter', sans-serif"
          }}>Laboratorio Alineadores Transparentes para Ortodoncia Invisible</p>
          </div>
        </div>

        <nav className="flex flex-col items-end gap-2">
          <div className="flex items-center gap-4 mb-2">
            <a href="tel:302-469-1979" className="text-white/60 hover:text-white text-xs tracking-widest uppercase transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              302-469-1979
            </a>
            <span className="w-px h-4 bg-white/20" />
            <a href="mailto:contacto@rio3d.com.co" className="text-white/60 hover:text-white text-xs tracking-widest uppercase transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              contacto@rio3d.com.co
            </a>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <Button className="bg-white text-black hover:bg-white/90 text-xs font-semibold tracking-[0.15em] uppercase px-5 py-2 rounded-none transition-all duration-300 hover:scale-105" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              SOY PACIENTE
            </Button>
            <button className="text-white/80 hover:text-white text-xs font-medium tracking-[0.15em] uppercase px-4 py-2 border border-white/20 hover:border-white/60 transition-all duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              SOY DOCTOR
            </button>
          </div>

          <div className="hidden md:flex items-center gap-2 mt-1">
            <button className="text-white/60 hover:text-white text-[10px] font-light tracking-[0.2em] uppercase transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              ENCUENTRE UN DOCTOR
            </button>
            <span className="w-px h-3 bg-white/20" />
            <button className="text-white/60 hover:text-white text-[10px] font-light tracking-[0.2em] uppercase transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              PREGUNTAS FRECUENTES
            </button>
          </div>

          <button className="md:hidden text-white/80 hover:text-white mt-1 transition-colors duration-300" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <div className="flex flex-col gap-1.5">
              <span className={`block w-6 h-px bg-current transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2.5" : ""}`} />
              <span className={`block w-4 h-px bg-current transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
              <span className={`block w-6 h-px bg-current transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2.5" : ""}`} />
            </div>
          </button>

          {menuOpen && <div className="md:hidden absolute top-28 right-6 bg-black/90 backdrop-blur-sm border border-white/10 p-5 flex flex-col gap-3 min-w-[200px]">
              <Button className="bg-white text-black hover:bg-white/90 text-xs font-semibold tracking-[0.15em] uppercase rounded-none w-full">
                SOY PACIENTE
              </Button>
              <button className="text-white/80 hover:text-white text-xs tracking-[0.15em] uppercase text-left transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
                SOY DOCTOR
              </button>
              <button className="text-white/60 hover:text-white text-xs tracking-[0.15em] uppercase text-left transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
                ENCUENTRE UN DOCTOR
              </button>
              <button className="text-white/60 hover:text-white text-xs tracking-[0.15em] uppercase text-left transition-colors duration-300" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
                PREGUNTAS FRECUENTES
              </button>
            </div>}
        </nav>
      </header>

      <div className="relative z-10 flex flex-col items-start justify-end min-h-[85vh] px-6 pb-16 !bg-[url(https://destined-muskox.10web.cloud/wp-content/uploads/2026/05/laboratorio-de-alineadores-dentales.webp)] md:px-12 lg:px-20 md:pb-24 text-primary-foreground">
        <div className={`transition-all duration-1000 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-4 mb-6">
            <span className="block w-16 h-px bg-white/40" />
            <span className="text-white/50 text-xs tracking-[0.3em] uppercase" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              Ortodoncia Invisible
            </span>
          </div>

          <h1 className="text-[clamp(4rem,12vw,9rem)] font-black leading-none text-white tracking-tight !font-sans" style={{
          fontFamily: "'Playfair Display', serif"
        }}>
            Rio 3D
          </h1>

          <div className={`mt-8 flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Button className="bg-white text-black hover:bg-white/90 text-sm font-semibold tracking-[0.2em] uppercase px-8 py-3 rounded-none transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              SOY PACIENTE
            </Button>
            <button className="text-white border border-white/30 hover:border-white text-sm font-medium tracking-[0.2em] uppercase px-8 py-3 transition-all duration-300 hover:bg-white/10" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              SOY DOCTOR
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
    </section>;
}